import React, {Component, useEffect } from 'react'; 
import Image from 'next/image';
import "aos/dist/aos.css";
import AOS from 'aos';
import { pushCleverTapEvent } from './pushCleverTapEvent';

const Finance1=(props)=> {
    useEffect(() => {
        AOS.init();
      }, []);
    const learnTrackEvent = () => {
        if (props.url.includes('/export-factoring/purchase-order-financing')) {
            pushCleverTapEvent("PO_Finance_Explore_Solution", { "PageName": 'PO_Finance' });
        }
    }
    return (
        <section className={props.classes}>
            <div className="bgblue lg:py-sp-100 md:py-20 sm:py-6 xm:py-20">
                    <div className='container h-full  lg:px-3 px-3 xm:px-2'>
                        <h2 className='text-center text-xxxl text-secondary font-bold mb-7'>{props.heading}</h2>
                        <div className='flex flex-wrap h-full items-center justify-center sm:flex-col sm:m-auto w-full max-w-[850px] m-auto'>
                            <div className='w-1/5 md:w-3/12 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                <div className={props.imageclasses}>
                                <Image className='max-w-[200%] xm:max-w-[180%] md:max-w-[180%] sm:max-w-[90%] sm:m-[auto] sm:mb-[-60px]' src={props.exploreimg} alt="Purchase Order Finance" width={440} height={255}/>
                                </div>
                            </div>
                            <div className='w-4/5 md:w-9/12 sm:w-full sm:m-auto' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                <div className='explore-heading bg-white shadow-md border-[#bdb8b8] border rounded-lg sm:py-5 sm:px-5 sm:pt-[60px] py-16 md:py-10 md:pl-44 xm:pl-44 md:pr-4 lg:pl-52 lg:pr-40'>
                                    <h2 className='text-lg text-secondary font-bold mb-3'>
                                        {props.title}</h2>
                                    <p className='text-sm text-secondary mb-5'>{props.subtitle}</p>
                                    <a href={props.url} onClick={learnTrackEvent} className='learncta bg-anchor-blue text-white text-sm w-[150px] h-[40px] justify-center rounded-xl cursor-pointer flex items-center bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]'>
                                    {props.learncta} 
                                    <span className='align-middle ml-1'> <svg className='ml-xsp' xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="rgba(255,255,255,1)"/></svg></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
             </div>
        </section>
      
        
    )
}

export default  Finance1;